import LableResult from './src/main'

export default LableResult



// WEBPACK FOOTER //
// ./src/views/question-review/components/LableResult/index.js